
<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Support Contacts</h4>
          </div>
        </div>

        <div class="page-btn">
          <a
              href="javascript:void(0);"
              class="btn btn-added"
              @click="openModal('new')"
          >
            <vue-feather type="plus-circle" class="me-2"></vue-feather>
            Add Support Contact
          </a>
        </div>
      </div>
      <!-- SUPPORT CONTACT TABLE -->
      <filter-table
          :extra-class="['table', 'datanew']"
          :columns="supportContacts.columns"
          :data="supportContacts.data.value"
          :filters="supportContacts.filters"
      >
        <template #header>
          <h4>Available Support Contacts</h4>
        </template>


        <template #bodyCell="{ column, record }">

          <template v-if="column.key === 'status'">
            <a-switch
                :checked="record.status"
                @change="updateSupportContactStatus(record.id)"
            />
          </template>

          <template v-if="column.key === 'action'">
            <td class="action-table-data">
              <div class="edit-delete-action">
                <a @click="openModal('update', record.id)" class="me-2 p-2 mb-0">
                  <i data-feather="edit" class="feather-edit"></i>
                </a>
                <a
                    @click="deleteSplashScreen(record.id)"
                    class="me-2 confirm-text p-2 mb-0"
                    href="javascript:void(0);"
                >
                  <i data-feather="trash-2" class="feather-trash-2"></i>
                </a>
              </div>
            </td>
          </template>
        </template>

        <!-- </template> -->
      </filter-table>
      <!-- SPLASH SCREEN TABLE -->
    </div>
  </div>

<SupportContactModal :support-contact-id="selectedSupportContactId" ref="supportContactModal"/>







</template>

<script setup>

import SupportContactModal from "@/views/pages/support/modals/support-contact-modal.vue";

import {useSupportContactStore} from "@/store/supportContactStore";
import {computed, onMounted, ref} from "vue";
import {confirm} from "@/utils/swal";

const supportContactStore = useSupportContactStore();

const selectedSupportContactId = ref(null);

const supportContacts = {
  filters: ["type", "contact"],
  columns: [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      sorter: {
        compare: (a, b) => {
          a = a.type.toLowerCase();
          b = b.type.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: "Contact",
      dataIndex: "contact",
      key: "contact",
      sorter: {
        compare: (a, b) => {
          a = a.contact.toLowerCase();
          b = b.contact.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },

    {
      title: "Is Active",
      dataIndex: "status",
      key: "status",
      sorter: {
        compare: (a, b) => {
          a = a.status.toLowerCase();
          b = b.status.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },

    {
      title: "Action",
      key: "action",
      sorter: true,
    },
  ],
  data: computed(() => supportContactStore.supportContact),
};


function openModal(action, id = null) {
  if (action === "update") {
    selectedSupportContactId.value = id;
  } else {
    selectedSupportContactId.value = null;
  }
  $("#supportContactModal").modal("show");
}



async function deleteSplashScreen(id) {
  confirm({
    title: "Are you sure about this?",
    message: "This contact will be deleted",
    callback: async (continueDelete) => {
      if (continueDelete) {
        await supportContactStore.deleteSupportContact(id);
      }
    },
  });
}

async function updateSupportContactStatus(id)
{
  await supportContactStore.updateSupportContactStatus(id);
}

onMounted(async () => {
  await supportContactStore.fetchSupportContact();
});



</script>

<style scoped>

</style>